<app-header *ngIf="hiddenHeader && user.type==='Cliente'"></app-header>
<app-header-seller *ngIf="hiddenHeaderSeller"></app-header-seller>
<router-outlet></router-outlet>
<app-order-created-snackbar 
  *ngIf="activeNotifications.length > 0 && _authService.isLoggedIn() && user && currentRoute !== '/login' && currentRoute !== '/'"
  [notifications]="activeNotifications"
  (notificationClosed)="onNotificationClosed($event)">
</app-order-created-snackbar>
<div *ngIf="isLoading" class="loader">
  <div class="lds-roller">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>